module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-cove-fluted-hayman-0.97471299.jpg";